import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import ReportingTypeForm from "./ReportingTypeForm";

export interface State {}

export interface CreateReportingTypeFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  codebooks: any[];
}

class CreateReportingTypeForm extends React.Component<
  CreateReportingTypeFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newReportingType = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newReportingType = values;
        }
      });
      return newReportingType;
    });
  }

  render() {
    const { translate, codebooks } = this.props;

    const { getFieldDecorator, getFieldValue } = this.props.form;

    return (
      <ReportingTypeForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        codebooks={codebooks}
        getFieldValue={getFieldValue}
      />
    );
  }
}

export default CreateReportingTypeForm;
